import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $dividendEvent,
  $dividendEventEdit,
  dividendEventMounted,
  getDividendEvent,
  updateDividendEvent,
} from './model'

export const useDividendEvent = () => {
  const dividendEvent = useStore($dividendEvent)
  const loading = useStore(getDividendEvent.pending)
  const updating = useStore(updateDividendEvent.pending)

  const dividendEventEdit = useStore($dividendEventEdit)

  React.useEffect(() => {
    dividendEventMounted()
  }, [])

  return { dividendEvent: dividendEvent, dividendEventEdit, loading, updating }
}
